import { render } from "./ReportDetailView.vue?vue&type=template&id=a2c3b5d6&scoped=true"
import script from "./ReportDetailView.vue?vue&type=script&lang=js"
export * from "./ReportDetailView.vue?vue&type=script&lang=js"

import "./ReportDetailView.vue?vue&type=style&index=0&id=a2c3b5d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c3b5d6"]])

export default __exports__